import { z } from 'zod';
import { playerIdNameParser } from '../commonInbounds/utils/playerInboundUtils';
const PokerRoomInfoMttTableSchema = z.object({
    tableName: z.string(),
    numPlayers: z.number(),
    avgStackSize: z.number()
});
const PokerRoomInfoPayoutPlaceSchema = z.object({
    place: z.number(),
    amount: z.string(),
    note: z.string().optional()
});
const PokerRoomInfoPayoutsInfoSchema = z.object({
    numStartingPlayers: z.number(),
    payouts: z.array(PokerRoomInfoPayoutPlaceSchema),
    sponsorInfo: z.string().optional(),
    pointsInfo: z.string().optional()
});
const PokerRoomInfoInboundSchema = z
    .object({
    roomName: z.string(),
    variantName: z.string(),
    variantType: z.string(),
    welcomeMessage: z.string().trim().optional(),
    roomOpenSince: z.string(),
    roomCreatorIdName: z.string().transform(playerIdNameParser).optional(),
    roomCode: z.string(),
    infoFields: z.array(z.tuple([z.string(), z.string()])),
    mttTables: z.array(PokerRoomInfoMttTableSchema).optional(),
    payoutsInfo: PokerRoomInfoPayoutsInfoSchema.optional()
})
    .transform(
// add _type
({ ...rest }) => ({
    _type: 'poker_room_info',
    ...rest
}));
export const POKER_ROOM_INFO_PAYLOAD_DEFINITION = {
    zodSchema: PokerRoomInfoInboundSchema
};
